module.exports = __webpack_public_path__ + "img/member_step.2dd26a30.png";